import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, FormControl, FormLabel, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { TextField, Button } from '@totalsoft/rocket-ui';
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import { withRights } from '../../../../../../providers/RightsConsumer';
import { RightsContext } from 'providers/RightsContext';
import { GridActionsWrapper } from 'components/common/CommonStyles';

const DecisionSummaryComponent = ({ t, decisionSummary, contractGenPermissions, onGenerateContract, onCalculateApproval }) => {
  const { hasRightGenerateContract, folderCalculateApproval } = useContext(RightsContext);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4} display='flex' gap={1} flexDirection='column'>
        <TextField
          disabled
          fullWidth
          value={decisionSummary.advanceCriterion || ''}
          label={t('DocumentEdit.Scoring.ScoringResult.AdvanceCriterion')}
        />
        <TextField
          disabled
          fullWidth
          value={decisionSummary.scoringResult || ''}
          label={t('DocumentEdit.Scoring.ScoringResult.ScoringResult')}
        />
        <TextField disabled fullWidth value={decisionSummary.decisionType || ''} label={t('Document.Decision.Summary.DecisionType')} />
      </Grid>
      <Grid item xs={12} sm={4} display='flex' gap={1} flexDirection='column'>
        <TextField
          disabled
          fullWidth
          value={decisionSummary.indebtednessDegree || ''}
          label={t('DocumentEdit.Scoring.ScoringResult.IndebtednessCriterion')}
        />
        <TextField disabled fullWidth value={decisionSummary.approvalLevel || ''} label={t('Document.Decision.Summary.ApprovalLevel')} />
        <TextField disabled fullWidth value={decisionSummary.finalDecision || ''} label={t('Document.Decision.Summary.FinalDecision')} />
      </Grid>
      <Grid item xs={12} sm={4} display='flex' gap={1} flexDirection='column'>
        <TextField
          disabled
          fullWidth
          value={decisionSummary.knockoutCriterion || ''}
          label={t('DocumentEdit.Scoring.ScoringResult.KnockoutCriterion')}
        />
        <FormControl sx={{ flexDirection: 'row', alignItems: 'center' }}>
          <FormLabel sx={{ fontSize: 'small', marginRight: 1 }} disabled>
            {t('Document.Decision.Summary.AutoDecision.Title')}
          </FormLabel>
          <RadioGroup sx={{ flexDirection: 'row' }}>
            <FormControlLabel
              label={t('Document.Decision.Summary.AutoDecision.Yes')}
              control={<Radio disabled checked={decisionSummary.autoApproval === true} />}
            />
            <FormControlLabel
              label={t('Document.Decision.Summary.AutoDecision.No')}
              control={<Radio disabled checked={decisionSummary.autoApproval === false} />}
            />
          </RadioGroup>
        </FormControl>
        <TextField
          disabled
          fullWidth
          value={decisionSummary.transactionCategoryName || ''}
          label={t('Document.Decision.Summary.TransactionCategory')}
        />
      </Grid>
      <GridActionsWrapper item>
        {contractGenPermissions.generateContractIsVisible === true && hasRightGenerateContract && (
          <Button
            color='primary'
            right
            onClick={onGenerateContract}
            disabled={contractGenPermissions == null || !contractGenPermissions.generateContractIsEnabled}
          >
            <AssignmentTurnedIn />
            {t('Document.Decision.Summary.GenerateContract')}
          </Button>
        )}
        <Button
          color='primary'
          variant='contained'
          onClick={onCalculateApproval}
          id={'folderDecisionSummary_calculateApproval'}
          disabled={!folderCalculateApproval || !decisionSummary?.canCalculateApproval}
        >
          {t('Folder.GeneralData.GeneralInfo.CalculateApproval')}
        </Button>
      </GridActionsWrapper>
    </Grid>
  );
};

DecisionSummaryComponent.propTypes = {
  t: PropTypes.func.isRequired,
  decisionSummary: PropTypes.object.isRequired,
  contractGenPermissions: PropTypes.object.isRequired,
  onGenerateContract: PropTypes.func.isRequired,
  onCalculateApproval: PropTypes.func
};

export default withTranslation()(withRights(DecisionSummaryComponent));
